module.exports = __webpack_public_path__ + "img/user-9.39e69317.svg";